import { createStore } from 'vuex';
import { CartProductos } from './CartProductos';

export default createStore({
  state: {
    cart: JSON.parse(localStorage.getItem('cart')) || [],
  },
  getters: {
    cartItemCount: (state) => {
      return state.cart.length;
    },
    cartWithTotals: (state) => {
      return state.cart.map((item) => {
        // Aplicar descuento si la cantidad es 1000 o más
        const precioMillar = parseFloat(item.datos.precioMillar);
        const precioColor = parseFloat(item.color.costoAdicional);
        const precioBase = parseFloat(item.datos.precio);

        let price =
          item.datos.cantidad >= 1000
            ? precioMillar + precioColor
            : precioBase + precioColor;

        return {
          ...item,
          totalPrice: (item.datos.cantidad * price).toFixed(2),
        };
      });
    },
    totalCartValue: (state, getters) => {
      return getters.cartWithTotals
        .reduce((total, item) => total + Number(item.totalPrice), 0)
        .toFixed(2);
    },
    cartItems: (state) => state.cart,
  },
  mutations: {
    ADD_TO_CART(state, item) {
      let found = state.cart.find((product) => product.id === item.id);
      if (found) {
        found.quantity++;
      } else {
        state.cart.push({ ...item, quantity: 1 });
      }
      localStorage.setItem('cart', JSON.stringify(state.cart));
    },
    REMOVE_FROM_CART(state, itemId) {
      let index = state.cart.findIndex((product) => product.id === itemId);
      if (index > -1) {
        state.cart.splice(index, 1);
      }
      localStorage.setItem('cart', JSON.stringify(state.cart));
    },
    REDUCE_FROM_CART(state, itemId) {
      const found = state.cart.find((product) => product.id === itemId);
      if (found) {
        if (found.quantity > 1) {
          found.quantity--;
        } else {
          state.cart = state.cart.filter((product) => product.id !== itemId);
        }
      }
      localStorage.setItem('cart', JSON.stringify(state.cart));
    },
  },
  actions: {
    addToCart({ commit }, item) {
      commit('ADD_TO_CART', item);
    },
    removeFromCart({ commit }, itemId) {
      commit('REMOVE_FROM_CART', itemId);
    },
  },
  modules: {
    cartProduct: CartProductos,
  },
});
